module.exports = "../images/desktop.jpg";